import type { ContentStatus } from './types';

interface RowModelAttributionInput {
  status: ContentStatus;
  model_used?: string | null;
  provider?: string | null;
}

interface RowModelAttribution {
  model_used: string | null;
  provider: string | null;
}

function normalizeValue(value?: string | null): string | null {
  const normalized = value?.trim();
  return normalized || null;
}

/**
 * Legacy model fields are selection data unless generation reaches a
 * provenance-bearing terminal state. Masking other rows prevents a
 * requested/default model being presented as execution provenance before the
 * runtime has corrected the row.
 */
export function resolveRowModelAttribution(
  row: RowModelAttributionInput,
): RowModelAttribution {
  if (
    !['completed', 'draft', 'published', 'needs_review'].includes(row.status)
  ) {
    return { model_used: null, provider: null };
  }

  return {
    model_used: normalizeValue(row.model_used),
    provider: normalizeValue(row.provider),
  };
}
